import { css } from '@emotion/core';
import { rgba, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var button = /*#__PURE__*/css("border:0;background:", rgba(colors.neutral.heavy.default, 0), ";outline:none;padding:0;");
export var thumbnail = {
  name: "te8o8m",
  styles: "border:2px solid transparent;transition:border 0.5s;width:52px;height:52px;border-radius:2px;&:not(:first-child){margin-left:12px;}"
};
export var selected = /*#__PURE__*/css("border:2px solid ", colors.neutral.trim.default, ";");
export var overlay = /*#__PURE__*/css("position:absolute;top:2px;bottom:0;left:6px;right:0;width:48px;height:48px;background-color:", rgba(colors.neutral.heavy.default, 0.6), ";color:", colors.neutral.subdued.default, ";padding-top:12px;");